<template>
  <div>
    <div v-if="customer" class="card p-3">
      <div>
        <b>{{ fullName(customer) }}</b>
      </div>
      <div>{{ customer.phone }}</div>
      <div>{{ customer.email }}</div>
      <div class="mt-3">
        <span class="label">Accounting Key:</span>
        {{ customer.accounting_key || "--" }}
      </div>
      <div class="mt-3">
        <div><span class="label">Membership:</span>{{ membershipName }}</div>
        <div v-if="customer.membership">
          <span class="label">Member Since:</span>{{ membershipDate }}
        </div>
        <div v-if="customer.membership">
          <span class="label">Expires:</span>{{ membershipExpDate }}
        </div>
        <div v-if="conflicts.membership" class="error-text text-danger">
          {{ conflicts.membership }}
        </div>
      </div>
      <div class="mt-3">
        <div><span class="label">Card on File:</span>{{ paymentMethod }}</div>
        <div v-if="conflicts.paymentMethod" class="error-text text-danger">
          {{ conflicts.paymentMethod }}
        </div>
      </div>
      <div class="mt-3">
        <span class="label">Billing Address:</span>
        <AddressLabel
          v-if="customer.primary_address"
          :address="customer.primary_address"
        />
        <span v-else>--</span>
      </div>
      <AddressTaxLabel class="mt-3" :address="customer.primary_address" />
      <div class="mt-3">
        <span class="label">Last Login:</span>
        {{ shortDate(customer.last_login_at) || "--" }}
      </div>
    </div>
    <div v-else class="card p-3 loading-card">
      <Spinner message="Loading preview..." />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapActions, mapState } from "vuex";

import AddressLabel from "@/components/AddressLabel.vue";
import AddressTaxLabel from "@/components/AddressTaxLabel.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    AddressLabel,
    Spinner,
    AddressTaxLabel
  },
  props: {
    customer: {
      type: Object,
      default: null
    },
    compareCustomer: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: ""
    }
  },
  computed: {
    ...mapState({
      paymentMethods: "paymentMethods"
    }),
    membershipName() {
      if (!this.customer.membership) {
        return "--";
      }
      return this.customer.membership.membership_program_name;
    },
    membershipDate() {
      return this.longDate(this.customer.membership.starts_at);
    },
    membershipExpDate() {
      return this.longDate(this.customer.membership.ends_at);
    },
    paymentMethod() {
      if (!this.customer.payment_method) {
        return "--";
      }
      const { last4, brand, ach_account_type } = this.customer.payment_method;
      if (this.customer.payment_method.payment_type === "card") {
        return `${brand} ...${last4}`;
      }
      if (this.customer.payment_method.payment_type === "ach") {
        return `${ach_account_type} ACH ...${last4}`;
      }
      return "--";
    },
    conflicts() {
      let conflicts = {};
      if (this.customer && this.compareCustomer) {
        conflicts = {
          paymentMethod: this.validatePaymentMethod(),
          membership: this.validateMembership()
        };
      }
      return conflicts;
    }
  },
  mounted() {
    if (!this.paymentMethods.length) {
      this.fetchPaymentMethods();
    }
  },
  methods: {
    ...mapActions(["fetchPaymentMethods"]),
    validatePaymentMethod() {
      let message = "";
      if (this.type === "duplicate") {
        if (this.customer.payment_method) {
          message = "This payment method will be lost!";
          if (!this.compareCustomer.payment_method) {
            message += " Consider swapping the accounts.";
          }
        }
      }
      return message;
    },
    validateMembership() {
      let message = "";
      if (this.customer.membership) {
        if (this.compareCustomer.membership) {
          if (
            moment(this.customer.membership.ends_at).isBefore(
              this.compareCustomer.membership.ends_at
            )
          ) {
            message = "This membership expires before the other account.";
          }
        } else if (this.type === "duplicate") {
          message = "This membership will be transferred.";
        }
      }
      return message;
    }
  }
};
</script>

<style lang="scss" scoped>
.label {
  font-weight: bold;
  margin-right: 5px;
}
.loading-card {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 150px;
}
</style>
